module.exports = __webpack_public_path__ + "static/media/pics6.c0ef6e82.png";